import { ConnectedRouter } from "connected-react-router";
import { History } from "history";
import moment from "moment";
import "moment/locale/it";
import React, { lazy, Suspense } from "react";
import { Dispatch } from "redux";
import IAction from "../models/IAction";
import BasePath from "./components/base-content/BasePath";
import ErrorViewer from "./components/error/ErrorViewer";
import LoadingIndicator from "./components/loading-indicator/LoadingIndicator";
import Toasts from "./components/toasts/Toasts";
moment.locale("it");

const Header = lazy(() => import("./components/header/Header"));

interface IProps {
    readonly history: History;
    readonly dispatch: Dispatch<IAction<any>>;
}
interface IState {}

export default class App extends React.Component<IProps, IState> {
    public render(): JSX.Element {
        return (
            <ConnectedRouter history={this.props.history}>
                <Suspense fallback={<LoadingIndicator isActive={true} />}>
                    <Header />
                    <Toasts />
                    <ErrorViewer />
                    <BasePath />
                </Suspense>
            </ConnectedRouter>
        );
    }
}
